








import {
  defineComponent,
  PropType,
} from '@vue/composition-api';
import { ExternalReportSettings } from '@/models/apis/externalReports/external_report_settings';
import { downloadObjectUrl } from '@/lib/downloadHelper';

export default defineComponent({
  props: {
    userSettings: {
      type: Object as PropType<ExternalReportSettings>,
      required: true,
    },
  },
  setup(props) {
    const downloadManual = () => {
      const manualName = props.userSettings.common.manual_download_file_name;
      downloadObjectUrl(props.userSettings.common.manual_download_link, manualName);
    };
    return {
      downloadManual,
    };
  },
});
